import type { ResultType } from '@/pages/YangbokOrg/questionFormTypes';

export const RESULT_TYPES: ResultType[] = [
  {
    key: 'readyMade',
    title: '활용 중심 실속형',
    recommendation: '기성복 + 수선 조합',
    summary: '웨딩 이후까지 생각하면 활용도가 가장 중요해요.',
    rarityPercent: 21,

    typeExplanation: {
      summary:
        '예복을 결혼식 하루만을 위한 옷으로 보기보다, 이후에도 자연스럽게 입을 수 있는 한 벌로 생각하는 타입이에요.',
      paragraphs: [
        '당신은 무조건 맞춤을 해야 한다는 말보다, 실제로 얼마나 자주 입을 수 있는지와 관리가 쉬운지를 더 중요하게 보는 편입니다.',
        '기성복을 기반으로 하되 어깨, 소매, 허리 정도를 수선하면 예산 부담을 줄이면서도 충분히 깔끔한 예복 스타일을 만들 수 있어요.',
        '다만 체형 차이가 크거나 촬영 핏을 중요하게 본다면, 기성복만으로는 한계가 있을 수 있어 반수제도 함께 비교해보는 것이 좋습니다.',
      ],
    },

    styleBars: [
      { label: '활용도', level: '매우 높음', value: 92 },
      { label: '예산 효율성', level: '높음', value: 82 },
      { label: '체형 보정 중요도', level: '보통', value: 55 },
      { label: '클래식한 실루엣', level: '보통', value: 58 },
      { label: '원단/디테일 관심도', level: '낮음', value: 38 },
      { label: '트렌디한 디자인', level: '보통', value: 52 },
    ],

    mainRecommendation: {
      title: '기성복 + 수선 조합',
      description:
        '예복을 결혼식 이후에도 활용하고 싶다면 기성복을 기반으로 필요한 부분만 수선하는 방식이 현실적입니다. 예산 부담은 줄이면서도 깔끔한 본식 스타일을 만들 수 있습니다.',
      reasons: [
        '결혼식 이후에도 출근, 행사, 격식 있는 자리에 활용하기 좋습니다.',
        '맞춤 제작보다 준비 기간이 짧고 일정 부담이 적습니다.',
        '필요한 부위만 수선하면 기본 핏을 충분히 정리할 수 있습니다.',
        '예산을 과하게 쓰지 않으면서 실용적인 선택이 가능합니다.',
      ],
    },

    upgradeConditions: [
      '기성복을 입었을 때 어깨나 허리 라인이 많이 어색한 편',
      '촬영 사진에서 핏이 중요하게 보였으면 하는 경우',
      '결혼식 이후에도 오래 입을 한 벌을 조금 더 잘 맞추고 싶은 경우',
      '기성복 브랜드에서 마음에 드는 핏을 찾기 어려운 경우',
    ],

    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '기성복 + 수선',
        description:
          '활용도와 예산 효율을 모두 생각한다면 가장 현실적인 선택입니다. 기본 핏이 맞는 브랜드를 찾는 것이 중요합니다.',
        highlight: true,
      },
      {
        tag: '핏이 아쉽다면?',
        title: '반수제 예복',
        description:
          '기성복에서 어깨나 허리 라인이 아쉽다면 반수제를 통해 체형 보정을 더 안정적으로 가져갈 수 있습니다.',
      },
      {
        tag: '예산을 더 아껴야 한다면?',
        title: '촬영 대여 + 본식 기성복',
        description:
          '촬영은 대여로 해결하고 본식에는 활용도 높은 기성복을 선택하는 방식도 가능합니다.',
      },
    ],

    matchedShopIds: ['v2', 'v3'],
  },

  {
    key: 'semiBespoke',
    title: '밸런스형 신랑',
    recommendation: '반수제',
    summary: '가장 많은 신랑님들이 선택하는 안정적인 방식이에요.',
    rarityPercent: 34,

    typeExplanation: {
      summary:
        '비싸 보이는 예복보다, 실제로 체형이 정리되어 보이고 촬영과 본식에서 안정적으로 어울리는 예복을 선호하는 타입이에요.',
      paragraphs: [
        '당신은 예복을 고를 때 가격만 보거나, 무조건 화려한 디자인을 고르는 타입은 아닙니다.',
        '촬영과 본식에서 실제로 몸이 정리되어 보이는지, 수정 과정이 부담스럽지 않은지, 결혼식 이후에도 어색하지 않게 입을 수 있는지를 함께 보는 편이에요.',
        '그래서 이 타입은 대부분 반수제를 가장 현실적인 선택으로 느끼지만, 체형 보정이나 완성도를 더 중요하게 생각한다면 수제/비스포크도 한 번쯤 고려해볼 만합니다.',
      ],
    },

    styleBars: [
      { label: '클래식한 실루엣', level: '높음', value: 74 },
      { label: '체형 보정 중요도', level: '매우 높음', value: 88 },
      { label: '트렌디한 디자인', level: '보통', value: 48 },
      { label: '원단/디테일 관심도', level: '보통', value: 58 },
      { label: '예산 효율성', level: '높음', value: 78 },
      { label: '촬영 활용도', level: '높음', value: 72 },
    ],

    mainRecommendation: {
      title: '반수제 예복',
      description:
        '기성복보다 체형 보정이 가능하고, 수제/비스포크보다 예산 부담이 적어 촬영과 본식 모두를 고려했을 때 가장 균형이 좋은 선택입니다.',
      reasons: [
        '체형 보정과 핏 안정감을 동시에 확보할 수 있습니다.',
        '촬영 + 본식 기준 예산 효율이 가장 좋습니다.',
        '수선/수정 과정이 수제보다 유연하고 부담이 적습니다.',
        '일정 안정성이 높아 촉박한 준비에도 대응 가능합니다.',
      ],
    },

    upgradeConditions: [
      '어깨, 허리, 팔 길이 등 체형 차이가 큰 편',
      '예복을 결혼식 이후에도 자주 입을 계획',
      '예산을 조금 더 쓰더라도 완성도를 우선',
      '원단, 라펠, 실루엣 같은 디테일을 직접 고르고 싶음',
    ],

    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '반수제 예복',
        description:
          '촬영 + 본식 기준으로 가장 현실적인 선택입니다. 핏과 예산의 균형이 가장 좋습니다.',
        highlight: true,
      },
      {
        tag: '조금 더 투자 가능하다면?',
        title: '수제/비스포크',
        description:
          '체형 보정, 원단 선택, 디테일 완성도를 더 중요하게 본다면 고려할 만합니다.',
      },
      {
        tag: '예산을 아껴야 한다면?',
        title: '촬영 대여 + 본식 중심',
        description:
          '실사용 목적을 나눠서 접근하는 방식이 좋습니다. 대여로 촬영을 커버하고 본식에 집중하세요.',
      },
    ],

    matchedShopIds: ['v1', 'v3'],
  },

  {
    key: 'bespoke',
    title: '클래식 장인형',
    recommendation: '비스포크 / 수제',
    summary: '시간을 들여 내 체형에 맞는 한 벌을 만드는 방식이에요.',
    rarityPercent: 9,

    typeExplanation: {
      summary:
        '빠른 결정이나 실속보다, 내 체형과 취향에 맞는 완성도 높은 한 벌을 중요하게 생각하는 타입이에요.',
      paragraphs: [
        '당신은 예복을 단순히 입는 옷이 아니라, 체형과 분위기를 정리해주는 하나의 완성된 결과물로 보는 편입니다.',
        '원단, 라펠, 어깨선, 허리 라인처럼 작은 디테일까지 직접 조율하고 싶다면 수제나 비스포크 방식이 가장 잘 맞을 수 있어요.',
        '다만 제작 기간과 예산 부담이 커질 수 있으므로, 촬영일과 본식일을 기준으로 충분한 여유를 두고 상담하는 것이 중요합니다.',
      ],
    },

    styleBars: [
      { label: '체형 보정 중요도', level: '매우 높음', value: 94 },
      { label: '원단/디테일 관심도', level: '매우 높음', value: 90 },
      { label: '클래식한 실루엣', level: '매우 높음', value: 88 },
      { label: '예산 효율성', level: '낮음', value: 35 },
      { label: '트렌디한 디자인', level: '보통', value: 46 },
      { label: '촬영 활용도', level: '높음', value: 70 },
    ],

    mainRecommendation: {
      title: '비스포크 / 수제 예복',
      description:
        '체형과 취향을 세밀하게 반영하고 싶다면 비스포크나 수제 예복이 가장 잘 맞습니다. 시간과 예산이 더 들지만, 완성도 높은 한 벌을 기대할 수 있습니다.',
      reasons: [
        '체형 차이를 가장 세밀하게 보정할 수 있습니다.',
        '원단, 라펠, 버튼, 실루엣 등 디테일 선택 폭이 넓습니다.',
        '결혼식 이후에도 오래 입을 수 있는 한 벌을 만들기 좋습니다.',
        '클래식한 스타일을 선호하는 경우 만족도가 높습니다.',
      ],
    },

    upgradeConditions: [
      '제작 기간을 충분히 확보할 수 있음',
      '예산보다 완성도를 더 중요하게 생각함',
      '기성복이나 반수제에서 핏 만족도가 낮았던 경험이 있음',
      '예복을 결혼 이후에도 오래 입고 싶음',
    ],

    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '비스포크 / 수제 예복',
        description:
          '완성도와 체형 보정을 가장 중요하게 본다면 가장 적합한 선택입니다.',
        highlight: true,
      },
      {
        tag: '현실적인 대안',
        title: '고급 반수제',
        description:
          '예산이나 일정이 부담된다면 원단과 수정 범위가 좋은 반수제 업체를 선택하는 것도 좋습니다.',
      },
      {
        tag: '주의할 점',
        title: '제작 기간 확보',
        description:
          '수제 예복은 상담, 가봉, 수정 과정이 필요하므로 촬영일 전에 충분한 시간을 확보해야 합니다.',
      },
    ],

    matchedShopIds: ['v1', 'v4'],
  },

  {
    key: 'fast',
    title: '일정 우선형',
    recommendation: '빠른 반수제 / 기성복',
    summary: '지금은 안정적인 일정 관리가 더 중요할 수 있어요.',
    rarityPercent: 12,

    typeExplanation: {
      summary:
        '완성도도 중요하지만, 지금 상황에서는 제작 기간과 일정 안정성이 가장 중요한 타입이에요.',
      paragraphs: [
        '예복은 제작과 수정 시간이 필요한 영역이라 일정이 촉박할수록 선택지가 줄어듭니다.',
        '당신은 지금 무리하게 완성도 높은 맞춤을 고르기보다, 촬영일과 본식일에 맞춰 안정적으로 준비 가능한 방식을 우선해야 할 가능성이 높아요.',
        '빠른 제작이 가능한 반수제나, 기성복에 수선을 더하는 조합이 현실적입니다. 상담 시에는 가격보다 제작 가능 일정을 먼저 확인하는 것이 좋습니다.',
      ],
    },

    styleBars: [
      { label: '일정 안정성', level: '매우 높음', value: 95 },
      { label: '예산 효율성', level: '높음', value: 75 },
      { label: '체형 보정 중요도', level: '보통', value: 56 },
      { label: '촬영 활용도', level: '높음', value: 68 },
      { label: '원단/디테일 관심도', level: '낮음', value: 34 },
      { label: '클래식한 실루엣', level: '보통', value: 52 },
    ],

    mainRecommendation: {
      title: '빠른 반수제 / 기성복',
      description:
        '촬영일이나 본식일이 가까운 상황이라면 제작 안정성이 가장 중요합니다. 빠른 제작이 가능한 반수제나 기성복 수선 조합이 현실적입니다.',
      reasons: [
        '일정이 촉박해도 준비 가능성이 높습니다.',
        '기본 핏을 빠르게 잡고 필요한 부분만 수정할 수 있습니다.',
        '촬영 대여와 본식 예복을 분리해 준비할 수 있습니다.',
        '상담 시 제작 가능 여부를 빠르게 판단할 수 있습니다.',
      ],
    },

    upgradeConditions: [
      '촬영일까지 여유가 최소 6주 이상 있음',
      '일정은 촉박하지만 체형 보정이 꼭 필요함',
      '기성복에서 맞는 사이즈를 찾기 어려움',
      '본식 이후에도 오래 입을 수 있는 예복을 원함',
    ],

    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '빠른 반수제',
        description:
          '일정과 핏을 모두 고려해야 한다면 빠른 제작이 가능한 반수제가 가장 안정적입니다.',
        highlight: true,
      },
      {
        tag: '더 빠르게 필요하다면?',
        title: '기성복 + 수선',
        description:
          '촬영이나 본식 일정이 가까우면 기성복을 고르고 필요한 부분만 수선하는 방식이 현실적입니다.',
      },
      {
        tag: '촬영이 급하다면?',
        title: '촬영 대여 우선',
        description:
          '촬영용 예복은 대여로 먼저 해결하고, 본식 예복은 따로 준비하는 방식도 가능합니다.',
      },
    ],

    matchedShopIds: ['v2', 'v3'],
  },

  {
    key: 'event',
    title: '촬영 중심형',
    recommendation: '대여 특화 반수제',
    summary: '본식뿐 아니라 촬영 결과물까지 중요하게 보는 타입이에요.',
    rarityPercent: 17,

    typeExplanation: {
      summary:
        '예복을 실제 착용감뿐 아니라 사진 속 결과물까지 함께 고려하는 타입이에요.',
      paragraphs: [
        '당신은 본식 하루의 예복보다 촬영, 리허설, 본식까지 이어지는 전체 이미지 완성도를 중요하게 봅니다.',
        '사진에서 어깨선, 허리 라인, 컬러감이 어떻게 보이는지를 중요하게 생각하기 때문에 촬영용 대여 구성이 다양한 업체가 잘 맞을 수 있어요.',
        '본식 예복은 안정적으로 가져가되, 촬영에서는 턱시도나 컬러감 있는 스타일을 추가로 활용하는 방식도 좋습니다.',
      ],
    },

    styleBars: [
      { label: '촬영 활용도', level: '매우 높음', value: 94 },
      { label: '트렌디한 디자인', level: '높음', value: 76 },
      { label: '체형 보정 중요도', level: '높음', value: 78 },
      { label: '클래식한 실루엣', level: '보통', value: 58 },
      { label: '예산 효율성', level: '보통', value: 55 },
      { label: '원단/디테일 관심도', level: '보통', value: 50 },
    ],

    mainRecommendation: {
      title: '대여 특화 반수제',
      description:
        '촬영 결과물까지 중요하게 본다면 본식 예복과 촬영 대여 구성을 함께 고려하는 반수제 방식이 잘 맞습니다.',
      reasons: [
        '촬영용 턱시도와 본식 예복을 함께 구성하기 좋습니다.',
        '사진에 잘 나오는 실루엣과 컬러를 선택할 수 있습니다.',
        '촬영과 본식의 분위기를 다르게 연출할 수 있습니다.',
        '대여 구성을 활용하면 비용 부담을 줄일 수 있습니다.',
      ],
    },

    upgradeConditions: [
      '촬영 콘셉트가 다양하고 의상 변화가 필요한 경우',
      '본식보다 촬영 결과물을 더 중요하게 보는 경우',
      '커플 화보나 야외 촬영을 적극적으로 진행할 계획',
      '턱시도, 화이트 재킷, 컬러 수트 등 다양한 스타일을 입어보고 싶음',
    ],

    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '대여 특화 반수제',
        description:
          '본식 예복은 안정적으로 준비하고, 촬영에서는 다양한 대여 구성을 활용하기 좋습니다.',
        highlight: true,
      },
      {
        tag: '촬영 컷을 더 살리고 싶다면?',
        title: '턱시도 / 컬러 수트 대여',
        description:
          '촬영 콘셉트에 맞춰 턱시도나 밝은 컬러 수트를 추가하면 결과물의 분위기를 살릴 수 있습니다.',
      },
      {
        tag: '예산을 줄이고 싶다면?',
        title: '촬영 대여 중심 구성',
        description:
          '본식용 예복은 최소화하고 촬영용 대여를 적극 활용하는 방식도 가능합니다.',
      },
    ],

    matchedShopIds: ['v2', 'v4'],
  },

  {
    key: 'practical',
    title: '미니멀 실용형',
    recommendation: '활용도 높은 기성복',
    summary: '결혼식 하루보다 이후 활용까지 생각하는 타입이에요.',
    rarityPercent: 19,

    typeExplanation: {
      summary:
        '화려한 예복보다 깔끔하고 오래 입을 수 있는 수트를 선호하는 타입이에요.',
      paragraphs: [
        '당신은 결혼식 당일의 특별함도 중요하지만, 이후 회사나 격식 있는 자리에서도 어색하지 않게 입을 수 있는지를 함께 봅니다.',
        '과한 턱시도 디테일보다는 네이비, 차콜, 블랙 계열의 미니멀한 기성복이나 반수제 구성이 잘 맞을 수 있어요.',
        '너무 웨딩 전용 느낌이 강한 예복보다는, 평소에도 활용 가능한 디자인을 고르는 것이 만족도가 높을 가능성이 큽니다.',
      ],
    },

    styleBars: [
      { label: '활용도', level: '매우 높음', value: 96 },
      { label: '미니멀한 디자인', level: '매우 높음', value: 88 },
      { label: '예산 효율성', level: '높음', value: 78 },
      { label: '클래식한 실루엣', level: '높음', value: 72 },
      { label: '트렌디한 디자인', level: '낮음', value: 32 },
      { label: '원단/디테일 관심도', level: '보통', value: 48 },
    ],

    mainRecommendation: {
      title: '활용도 높은 기성복',
      description:
        '결혼식 이후에도 입을 수 있는 수트를 원한다면 미니멀한 기성복이나 활용도 높은 반수제 구성이 좋습니다.',
      reasons: [
        '결혼식 이후에도 다양한 자리에서 활용할 수 있습니다.',
        '과한 웨딩 디테일이 없어 오래 입기 좋습니다.',
        '기본 컬러 중심이라 스타일 실패 확률이 낮습니다.',
        '수선만 잘해도 깔끔한 실루엣을 만들 수 있습니다.',
      ],
    },

    upgradeConditions: [
      '기성복에서 핏이 잘 맞지 않는 경우',
      '기본 수트지만 더 정돈된 실루엣을 원하는 경우',
      '예복을 장기적으로 입을 계획이 확실한 경우',
      '원단 퀄리티나 착용감을 더 중요하게 보는 경우',
    ],

    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '미니멀 기성복',
        description:
          '웨딩 이후 활용까지 생각한다면 가장 실용적인 선택입니다.',
        highlight: true,
      },
      {
        tag: '핏을 더 챙기고 싶다면?',
        title: '활용도 높은 반수제',
        description:
          '기본 디자인은 유지하면서 체형 보정만 더하고 싶다면 반수제가 좋습니다.',
      },
      {
        tag: '촬영도 고려한다면?',
        title: '본식 기성복 + 촬영 대여',
        description:
          '본식은 활용도 높은 수트로, 촬영은 대여로 분위기를 더하는 방식이 좋습니다.',
      },
    ],

    matchedShopIds: ['v2', 'v3'],
  },

  {
    key: 'stylish',
    title: '스타일 우선형',
    recommendation: '트렌디 반수제',
    summary: '착용감보다 분위기와 실루엣 만족도가 중요한 타입이에요.',
    rarityPercent: 14,

    typeExplanation: {
      summary:
        '예복을 입었을 때의 분위기, 사진 속 실루엣, 전체적인 스타일 완성도를 중요하게 생각하는 타입이에요.',
      paragraphs: [
        '당신은 무난한 정장보다 조금 더 세련돼 보이고, 촬영이나 본식에서 존재감이 있는 스타일을 선호할 가능성이 높습니다.',
        '트렌디한 패턴을 잘 다루는 반수제 업체나, 컬러, 라펠, 핏 제안이 다양한 업체를 우선적으로 보는 것이 좋아요.',
        '다만 유행성이 강한 스타일은 시간이 지나면 어색해질 수 있으니, 본식용은 안정감 있게 잡고 촬영에서 포인트를 주는 방식도 좋습니다.',
      ],
    },

    styleBars: [
      { label: '트렌디한 디자인', level: '매우 높음', value: 92 },
      { label: '촬영 활용도', level: '높음', value: 82 },
      { label: '실루엣 만족도', level: '매우 높음', value: 88 },
      { label: '클래식한 실루엣', level: '보통', value: 52 },
      { label: '예산 효율성', level: '보통', value: 45 },
      { label: '원단/디테일 관심도', level: '높음', value: 68 },
    ],

    mainRecommendation: {
      title: '트렌디 반수제',
      description:
        '스타일과 실루엣 만족도를 중요하게 본다면 트렌디한 패턴과 다양한 제안을 해주는 반수제 업체가 잘 맞습니다.',
      reasons: [
        '촬영과 본식에서 분위기를 살리기 좋습니다.',
        '컬러, 라펠, 핏 등 스타일 선택 폭이 넓습니다.',
        '체형 보정과 트렌디한 실루엣을 함께 가져갈 수 있습니다.',
        '기성복보다 개인 취향을 반영하기 쉽습니다.',
      ],
    },

    upgradeConditions: [
      '촬영에서 확실한 스타일 포인트를 주고 싶음',
      '무난한 정장보다 세련된 인상을 원함',
      '라펠, 컬러, 실루엣에 관심이 많음',
      '예산보다 사진 속 분위기 만족도가 더 중요함',
    ],

    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '트렌디 반수제',
        description:
          '핏 보정과 스타일 만족도를 함께 가져가기에 가장 좋은 선택입니다.',
        highlight: true,
      },
      {
        tag: '더 과감하게 가고 싶다면?',
        title: '촬영용 포인트 수트',
        description:
          '본식 예복은 안정적으로, 촬영에서는 컬러나 턱시도로 분위기를 더할 수 있습니다.',
      },
      {
        tag: '유행이 걱정된다면?',
        title: '클래식 기반 반수제',
        description:
          '전체 실루엣은 클래식하게 잡고 디테일만 트렌디하게 조절하는 방식이 좋습니다.',
      },
    ],

    matchedShopIds: ['v4', 'v2'],
  },

  {
    key: 'classic',
    title: '클래식 취향형',
    recommendation: '비스포크 / 클래식 수트',
    summary: '10년 뒤에도 어색하지 않은 스타일을 선호하는 타입이에요.',
    rarityPercent: 11,

    typeExplanation: {
      summary:
        '유행을 따라가기보다 오래 봐도 어색하지 않은 정제된 수트 스타일을 선호하는 타입이에요.',
      paragraphs: [
        '당신은 화려하거나 튀는 예복보다, 클래식한 비율과 안정적인 실루엣에서 만족감을 느낄 가능성이 높습니다.',
        '네이비, 차콜, 블랙 같은 기본 컬러와 좋은 원단, 균형 잡힌 라펠, 자연스러운 어깨선이 중요하다면 클래식 수트나 비스포크 방향을 고려해볼 만합니다.',
        '이 타입은 트렌디한 스타일보다 시간이 지나도 촌스럽지 않은 결과물을 더 중요하게 생각하는 편입니다.',
      ],
    },

    styleBars: [
      { label: '클래식한 실루엣', level: '매우 높음', value: 96 },
      { label: '원단/디테일 관심도', level: '높음', value: 82 },
      { label: '체형 보정 중요도', level: '높음', value: 76 },
      { label: '트렌디한 디자인', level: '낮음', value: 28 },
      { label: '활용도', level: '높음', value: 74 },
      { label: '예산 효율성', level: '보통', value: 46 },
    ],

    mainRecommendation: {
      title: '비스포크 / 클래식 수트',
      description:
        '오래 봐도 어색하지 않은 예복을 원한다면 클래식한 비율과 좋은 원단을 중심으로 한 비스포크 또는 클래식 수트가 잘 맞습니다.',
      reasons: [
        '유행을 타지 않는 안정적인 실루엣을 만들 수 있습니다.',
        '원단과 디테일 선택을 통해 완성도를 높일 수 있습니다.',
        '결혼식 이후에도 격식 있는 자리에서 활용하기 좋습니다.',
        '차분하고 고급스러운 인상을 만들기 좋습니다.',
      ],
    },

    upgradeConditions: [
      '예복을 장기적으로 활용할 계획',
      '무난하지만 고급스러운 인상을 선호',
      '원단과 라펠 같은 디테일에 관심이 있음',
      '트렌디한 스타일보다는 클래식한 분위기를 원함',
    ],

    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '클래식 수트 / 비스포크',
        description:
          '오래 봐도 어색하지 않은 스타일을 원한다면 가장 잘 맞는 선택입니다.',
        highlight: true,
      },
      {
        tag: '예산을 조절한다면?',
        title: '클래식 반수제',
        description:
          '비스포크가 부담된다면 클래식한 패턴을 잘 다루는 반수제 업체도 좋은 대안입니다.',
      },
      {
        tag: '촬영 분위기를 살리고 싶다면?',
        title: '본식 클래식 + 촬영 포인트',
        description:
          '본식은 클래식하게, 촬영은 턱시도나 밝은 컬러 대여로 분위기를 더할 수 있습니다.',
      },
    ],

    matchedShopIds: ['v1', 'v4'],
  },

  {
    key: 'minimal',
    title: '합리적 투자형',
    recommendation: '가성비 중심 반수제',
    summary: '가장 효율 좋은 선택지를 찾는 타입이에요.',
    rarityPercent: 24,

    typeExplanation: {
      summary:
        '무조건 저렴한 선택보다, 지불한 비용 대비 만족도가 높은 선택을 찾는 타입이에요.',
      paragraphs: [
        '당신은 예복에 과하게 투자하고 싶지는 않지만, 너무 저렴해서 결과물이 아쉬운 선택도 피하고 싶어합니다.',
        '가성비 중심 반수제는 기본적인 체형 보정과 촬영/본식 구성을 챙기면서도 예산을 크게 넘기지 않을 수 있어 가장 현실적인 선택이 될 수 있어요.',
        '중요한 것은 가장 싼 업체를 찾는 것이 아니라, 필요한 구성만 정확하게 가져가고 불필요한 옵션을 줄이는 것입니다.',
      ],
    },

    styleBars: [
      { label: '예산 효율성', level: '매우 높음', value: 94 },
      { label: '체형 보정 중요도', level: '높음', value: 70 },
      { label: '활용도', level: '높음', value: 72 },
      { label: '클래식한 실루엣', level: '보통', value: 60 },
      { label: '트렌디한 디자인', level: '보통', value: 46 },
      { label: '원단/디테일 관심도', level: '낮음', value: 36 },
    ],

    mainRecommendation: {
      title: '가성비 중심 반수제',
      description:
        '예산 효율을 중요하게 보면서도 기본적인 핏과 촬영 구성을 챙기고 싶다면 가성비 중심 반수제가 가장 현실적인 선택입니다.',
      reasons: [
        '기성복보다 체형 보정 만족도를 기대할 수 있습니다.',
        '수제보다 예산 부담이 적습니다.',
        '촬영과 본식 구성을 함께 챙기기 좋습니다.',
        '필요한 옵션만 선택하면 비용을 효율적으로 관리할 수 있습니다.',
      ],
    },

    upgradeConditions: [
      '기본 예산보다 조금 더 쓸 수 있음',
      '수정 대응이나 상담 퀄리티를 중요하게 봄',
      '촬영용 대여까지 포함된 구성을 원함',
      '너무 저렴한 선택으로 결과물이 아쉬울까 걱정됨',
    ],

    situationCards: [
      {
        tag: '현재 가장 잘 맞는 방향',
        title: '가성비 중심 반수제',
        description:
          '가격과 결과물의 균형을 생각했을 때 가장 현실적인 선택입니다.',
        highlight: true,
      },
      {
        tag: '예산을 더 줄이고 싶다면?',
        title: '기성복 + 기본 수선',
        description:
          '기본 핏이 잘 맞는 기성복을 찾을 수 있다면 비용을 더 줄일 수 있습니다.',
      },
      {
        tag: '조금 더 투자한다면?',
        title: '구성 좋은 반수제',
        description:
          '셔츠, 촬영 대여, 본식 구성이 포함된 패키지를 비교해보는 것이 좋습니다.',
      },
    ],

    matchedShopIds: ['v2', 'v3'],
  },
];
